import {
  ComplaintAsCase,
  complaintAsStatusLabel,
  complaintAsTypeLabel,
} from '../../../types/complaintAs';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../contract/ContractPanel.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import '../../quality/ComplaintAsPanel.css';

interface Props {
  detail: ComplaintAsCase;
}

function StatusBadge({
  status,
  approvalInProgress,
}: {
  status?: string | null;
  approvalInProgress?: boolean | null;
}) {
  const key = approvalInProgress
    ? 'pending'
    : (status || 'RECEIVED').toLowerCase().replace('_', '-');
  return (
    <span className={`cas-status is-${key}`}>
      {complaintAsStatusLabel(status, approvalInProgress)}
    </span>
  );
}

function ComplaintAsPreviewView({ detail }: Props) {
  return (
    <div className="ncr-detail">
      <div
        className="ifs-sheet"
        style={{ marginBottom: 14, padding: '12px 14px', background: '#fff' }}
      >
        <div className="ifs-sheet__top" style={{ marginBottom: 0 }}>
          <div>
            <h4 className="ifs-sheet__title" style={{ margin: 0, fontSize: 15 }}>
              {detail.customerName || detail.productName || '불만/AS'}
            </h4>
            <p className="ifs-sheet__subtitle" style={{ margin: '4px 0 0' }}>
              {detail.caseNo || '-'} ·{' '}
              {complaintAsStatusLabel(detail.status, detail.approvalInProgress)}
            </p>
          </div>
          <ApprovalStampBox
            authorName={detail.authorName || detail.handlerName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
      </div>
      <section className="ncr-detail__card">
        <h3>기본 정보</h3>
        <dl>
          <dt>접수번호</dt>
          <dd>{detail.caseNo || '-'}</dd>
          <dt>접수일</dt>
          <dd>{detail.receivedDate || '-'}</dd>
          <dt>유형</dt>
          <dd>{complaintAsTypeLabel(detail.caseType)}</dd>
          <dt>상태</dt>
          <dd>
            <StatusBadge status={detail.status} approvalInProgress={detail.approvalInProgress} />
          </dd>
          <dt>담당자</dt>
          <dd>{detail.handlerName || '-'}</dd>
        </dl>
      </section>
      <section className="ncr-detail__card">
        <h3>고객·제품</h3>
        <dl>
          <dt>고객명</dt>
          <dd>{detail.customerName || '-'}</dd>
          <dt>연락처</dt>
          <dd>{detail.customerContact || '-'}</dd>
          <dt>제품명</dt>
          <dd>{detail.productName || '-'}</dd>
          <dt>규격</dt>
          <dd>{detail.productSpec || '-'}</dd>
          <dt>LOT</dt>
          <dd>{detail.lotNo || '-'}</dd>
          <dt>수량</dt>
          <dd>{detail.qty || '-'}</dd>
        </dl>
      </section>
      <section className="ncr-detail__card is-wide">
        <h3>내용·조치</h3>
        <dl>
          <dt>접수 내용</dt>
          <dd>{detail.content || '-'}</dd>
          <dt>원인</dt>
          <dd>{detail.cause || '-'}</dd>
          <dt>조치 내용</dt>
          <dd>{detail.actionText || '-'}</dd>
          <dt>조치 결과</dt>
          <dd>{detail.actionResult || '-'}</dd>
          <dt>비고</dt>
          <dd>{detail.remark || '-'}</dd>
        </dl>
      </section>
    </div>
  );
}

export default ComplaintAsPreviewView;
